import React, { useEffect, useState } from 'react'; 
import Sidebar from './Sidebar'; 
import Info from './Info';
import axios from 'axios';
import { BASE_URL, BASE_FILE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { FaLevelUpAlt, FaPen, FaTrash } from 'react-icons/fa';
 
function Ads() {  
    const accessToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);
    const [ads, setAds] = useState([]);
    function onGetData() {
        setIsLoading(true);
        axios.get(`${BASE_URL}/vendor/ads`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setAds(res.data.data); 
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    }
    useEffect(() => {
        document.title = 'Infomart | Client Ads';
        onGetData(); 
    }, []); 
    const onDeleteData = async (id) => {
        const confirmed = window.confirm('Are you sure you want to delete this data?');
        if (confirmed) {
            await axios.post(`${BASE_URL}/vendor/ads/delete`, { id }, {
                headers: { 
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}` 
                } 
            }).then((res) => {
                toast.success(res.data.msg, { autoClose: 3000 });
                onGetData();
            }).catch((res) => {
                toast.error(res.response.data.msg, { autoClose: 3000 });
            });
        } 
    } 
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?  
                        <h5 className="text-center mt-5">Loading...</h5>
                    : 
                        <div style={{ flex: 1 }}>
                            <p style={{ fontSize: 13, color: '#856404', backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: 6, padding: '8px 12px', marginBottom: 10 }}>
                                For pop up ads please contact admin via email <a href="mailto:iam.infomart@gmail.com" style={{ fontWeight: 'bold', color: '#856404' }}>iam.infomart@gmail.com</a> or phone <a href="tel:+918240971068" style={{ fontWeight: 'bold', color: '#856404' }}>+91 8240971068</a>
                            </p>
                            <div className="card">
                                <div className="card-header fw-bold" style={{whiteSpace:'nowrap'}}>
                                    Your Advertisements  
                                    <Link to="/client/ads/create" className="float-end text-decoration-none">New Ads</Link>
                                </div>  
                                {/* <div className="card-body"> */}
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Image</th> 
                                                <th scope="col">Page</th>
                                                <th scope="col">Position</th>
                                                <th scope="col">From Date</th>
                                                <th scope="col">To Date</th>
                                                <th scope="col">Location</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Action</th>
                                            </tr> 
                                        </thead>
                                        <tbody className="align-middle">
                                            {ads && ads.length > 0 ? (
                                                ads.map((data, i) => {
                                                    const today = new Date();
                                                    const expiryDate = new Date(data.to_date);
                                                    today.setHours(0, 0, 0, 0);  
                                                    const isExpired = expiryDate < today; 
                                                    return ( 
                                                        <tr key={i}> 
                                                            <th scope="row">{i + 1}</th>
                                                            <td><img src={BASE_FILE_URL + data.image} className="img-thumbnail" height={120} width={120} /></td>
                                                            <td>{data.page}</td>
                                                            <td>{data.position}</td> 
                                                            <td>{format(data.from_date, 'dd MMM, yyyy')}</td>
                                                            <td>{format(data.to_date, 'dd MMM, yyyy')}</td> 
                                                            <td>{data.location}</td>
                                                            <td>
                                                                {data.status == 'Active' ?
                                                                    <span className="badge bg-success">{data.status}</span>
                                                                :
                                                                    <span className="badge bg-danger">{data.status}</span>
                                                                } 
                                                            </td>
                                                            <td className="text-center">   
                                                                {isExpired || data.status == 'Inactive' ? 
                                                                    <Link to={'/client/ads/' + data.id + '/upgrade'} className="btn btn-success btn-sm"><FaLevelUpAlt /></Link>
                                                                : null }     
                                                                <button className="btn btn-danger btn-sm ms-1" onClick={() => onDeleteData(data.id)}><FaTrash /></button>
                                                            </td>     
                                                        </tr>
                                                    );  
                                                }) 
                                            ) : (
                                                <tr>
                                                    <th colSpan="9" className="text-center">No data available.</th>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    } 
                </div>
            </div> 
        </div>
    );
}
export default Ads; 